import React from 'react';
import {Text, View} from 'react-native';
import {Portal, Dialog} from 'react-native-paper';
import {Typography} from 'src/styles';
import {usePermissionError} from 'src/contexts/PermissionErrorContext';
import {useStyle} from 'src/providers/style';
import {IconButton} from 'src/design-system';

interface Props {
  type?: string;
}

const PermissionDeniedNotification = ({type = 'snackbar'}: Props) => {
  const {errorMessage, clearError} = usePermissionError();
  const styles = useStyle();

  if (type === 'snackbar') {
    return (
      <Portal>
        <Dialog
          visible={!!errorMessage}
          onDismiss={clearError}
          style={[
            styles.backgroundColorWhite,
            styles.borderRadius,
            styles.alignSelfCenter,
            styles.width,
            [styles.maxModalWidth, styles.maxHeight],
            styles.margin0,
          ]}>
          <View>
            <View style={[styles.row, styles.alignCenter, styles.padding]}>
              <Text style={[Typography.H4, styles.flex]}>{'Error'}</Text>
              <IconButton
                onPress={() => {
                  clearError();
                }}
                icon={'close'}
                type={'icon'}
              />
            </View>
            <View
              style={[
                styles.paddingHorizontal,
                styles.paddingBottom,
                styles.height,
              ]}>
              <Text style={[Typography.P4]}>
                {errorMessage || 'You do not have permission'}
              </Text>
            </View>
          </View>
        </Dialog>
      </Portal>
    );
  } else {
    return (
      <>
        {errorMessage && <Text style={styles.errorMsg}>* {errorMessage}</Text>}
      </>
    );
  }
};

export default PermissionDeniedNotification;
